import type { Classroom } from "@classroom/domain";
import { useState } from "react";
import { useTranslation } from "./i18n";

export function EmptyClassDeletion({
  classroom,
  readOnly,
  onDelete,
}: {
  classroom: Classroom;
  readOnly: boolean;
  onDelete: (classId: string, confirmedName: string) => Promise<void>;
}) {
  const { t } = useTranslation("rosterAdmin");
  const [name, setName] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  return (
    <details className="paper-card roster-class-setup">
      <summary aria-label={t("deleteEmptyClass")}>{t("deleteEmptyClass")}</summary>
      <form
        className="compact-form"
        data-save-state={busy ? "saving" : name ? "dirty" : "saved"}
        onSubmit={async (event) => {
          event.preventDefault();
          if (readOnly || busy || name.trim() !== classroom.name.trim()) return;
          setBusy(true);
          setError("");
          try {
            await onDelete(classroom.id, name);
          } catch (cause) {
            const code = cause instanceof Error ? cause.message : "";
            setError(
              t(
                code === "class-not-empty"
                  ? "emptyBlocked"
                  : code === "empty-class-confirmation"
                    ? "emptyChanged"
                    : "emptyFailed",
              ),
            );
          } finally {
            setBusy(false);
          }
        }}
      >
        <p>{t("deleteEmptyNote")}</p>
        <strong>{classroom.name}</strong>
        <label>
          {t("deleteEmptyName")}
          <input
            value={name}
            onChange={(event) => setName(event.target.value)}
            disabled={readOnly || busy}
            autoComplete="off"
          />
        </label>
        {error && (
          <p role="alert" className="form-error">
            {error}
          </p>
        )}
        <button
          type="submit"
          className="danger-text"
          disabled={readOnly || busy || !name.trim() || name.trim() !== classroom.name.trim()}
        >
          {t(busy ? "deletingEmpty" : "deleteEmptyClass")}
        </button>
      </form>
    </details>
  );
}
